import { AfterViewInit, Component, ElementRef, NgZone, OnDestroy } from "@angular/core";

import { TranslateService } from "@ngx-translate/core";
import { BfxMouseModifierKeyService } from "app/bfx-common/services/bfx-mouse-modifier-key.service";
import { SystemConfigPromiseService } from "shared/cubiq-services";
import { BfxBaseBlotterColumnSelectorService } from "../../bfx-base-blotter/bfx-base-blotter-columnselector.service";

export const DEFAULT_ROW_HEIGHT: number = 29;

// import { LoggerService } from "@bfx/logger";
// const logger = LoggerService.for(__dirname);

import { BfxFwdRollBaseBlotterComponent } from "app/bfx-blotter-intervention/fwd-roll-pricing/bfx-fwd-roll-base-blotter";
import { FwdRollOrdersTableDefinitionFactory } from "shared/cubiq-services/model/FwdRollOrdersTableDefinitionFactory";
import { FwdRollRowType } from "shared/cubiq-model-multi-asset";
import { LockRowRenderer } from "app/bfx-blotter-intervention/fwd-roll-pricing/renderers/LockRowRenderer";
import { OrderStatusRenderer } from "app/bfx-blotter-intervention/fwd-roll-pricing/renderers/OrderStatusRenderer";
import { FwdRollFwdMarkupEditor } from "app/bfx-blotter-intervention/fwd-roll-pricing/editors/FwdRollFwdMarkupEditor";
import { FwdRollMarketPtsEditor } from "app/bfx-blotter-intervention/fwd-roll-pricing/editors/FwdRollMarketPtsEditor";
import { FwdRollClientPtsEditor } from "app/bfx-blotter-intervention/fwd-roll-pricing/editors/FwdRollClientPtsEditor";
import { CommonIntentRenderer } from "app/bfx-blotter-orders/renderers/CommonIntentRenderer";

@Component({
  selector: "bfx-fwd-roll-orders-grid",
  templateUrl: "./html/bfx-fwd-roll-orders-grid.html",
  standalone: false,
})
export class BfxFwdRollOrdersBlotterComponent
  extends BfxFwdRollBaseBlotterComponent
  implements OnDestroy, AfterViewInit
{
  public frameworkComponents: any = {
    selectionRenderer: LockRowRenderer,
    orderStatusRenderer: OrderStatusRenderer,
    intentRenderer: CommonIntentRenderer,
    fwdMarkupSpinner: FwdRollFwdMarkupEditor,
    clientPtsSpinner: FwdRollClientPtsEditor,
    marketPtsSpinner: FwdRollMarketPtsEditor,
  };
  constructor(
    BfxBlotterElement: ElementRef,
    tableDefinitionFactory: FwdRollOrdersTableDefinitionFactory,
    translationService: TranslateService,
    columnSelectorService: BfxBaseBlotterColumnSelectorService,
    sysConfigService: SystemConfigPromiseService,
    mouseModifierKeyService: BfxMouseModifierKeyService,
    zone: NgZone,
  ) {
    super(
      BfxBlotterElement,
      tableDefinitionFactory,
      translationService,
      columnSelectorService,
      sysConfigService,
      mouseModifierKeyService,
      zone,
    );
  }

  /**
   * Datamodel is taken from the portfoliomodel ordersData
   * @returns
   */
  protected override getGridDataModel() {
    return this.portfolioModel.ordersData;
  }

  public override getRowType(): FwdRollRowType {
    return FwdRollRowType.ORDER;
  }
}
